// extracted by mini-css-extract-plugin
module.exports = {"heightWatching":"ProviderInfoHeader_heightWatching__12zy1","title":"ProviderInfoHeader_title__aE4ZJ","remove":"ProviderInfoHeader_remove__26Uwk"};